import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaTimes, FaFlag } from 'react-icons/fa';

const ReportModal = ({
  isOpen,
  onClose,
  reportForm,
  setReportForm,
  reportSubmitting,
  onSubmit
}) => {
  const { t } = useTranslation();
  if (!isOpen) return null;

  const handleInputChange = (e) => {
    setReportForm({
      ...reportForm,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 p-4" style={{ background: 'rgba(5,16,4,0.5)' }}>
      <div style={{ background: '#FCFBF5', borderRadius: '28px', maxWidth: '460px', width: '100%', maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 20px 50px rgba(5,16,4,0.25)' }}>
        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '16px', padding: '22px 26px', borderBottom: '1px solid rgba(5,16,4,0.08)' }}>
          <div className="flex items-center gap-3">
            <div style={{ width: '36px', height: '36px', borderRadius: '999px', background: 'rgba(239,76,35,0.12)', display: 'grid', placeItems: 'center' }}>
              <FaFlag size={14} style={{ color: '#EF4C23' }} />
            </div>
            <h2 style={{ margin: 0, fontFamily: 'Fraunces, Georgia, serif', fontWeight: 700, fontSize: '19px' }}>{t('restaurant.report')}</h2>
          </div>
          <button
            onClick={onClose}
            style={{ flexShrink: 0, border: 'none', cursor: 'pointer', width: '36px', height: '36px', borderRadius: '999px', background: 'transparent', color: 'rgba(5,16,4,0.4)', display: 'grid', placeItems: 'center' }}
            onMouseEnter={(e) => { e.currentTarget.style.background = 'rgba(5,16,4,0.06)'; }}
            onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
          >
            <FaTimes size={16} />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={onSubmit} style={{ padding: '26px', display: 'flex', flexDirection: 'column', gap: '18px' }}>
          <label style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <span style={{ fontFamily: 'Archivo, sans-serif', fontSize: '12.5px', fontWeight: 600, letterSpacing: '0.08em', textTransform: 'uppercase', color: 'rgba(5,16,4,0.6)' }}>
              {t('restaurant.reportReason')}
            </span>
            <select
              name="reason"
              value={reportForm.reason}
              onChange={handleInputChange}
              style={{ border: '1px solid rgba(5,16,4,0.14)', borderRadius: '999px', padding: '12px 18px', fontFamily: 'Poppins, sans-serif', fontSize: '15px', background: '#FFFFFF', color: '#051004', outline: 'none' }}
              required
            >
              <option value="">{t('restaurant.selectReason')}</option>
              <option value="inappropriate_content">{t('restaurant.reportReasons.inappropriateContent')}</option>
              <option value="fake_information">{t('restaurant.reportReasons.fakeInformation')}</option>
              <option value="spam">{t('restaurant.reportReasons.spam')}</option>
              <option value="harassment">{t('restaurant.reportReasons.harassment')}</option>
              <option value="illegal_activity">{t('restaurant.reportReasons.illegalActivity')}</option>
              <option value="other">{t('restaurant.reportReasons.other')}</option>
            </select>
          </label>

          <label style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <span style={{ fontFamily: 'Archivo, sans-serif', fontSize: '12.5px', fontWeight: 600, letterSpacing: '0.08em', textTransform: 'uppercase', color: 'rgba(5,16,4,0.6)' }}>
              {t('restaurant.detailedDescription')}
            </span>
            <textarea
              name="description"
              value={reportForm.description}
              onChange={handleInputChange}
              rows="4"
              style={{ border: '1px solid rgba(5,16,4,0.14)', borderRadius: '20px', padding: '14px 18px', fontFamily: 'Poppins, sans-serif', fontSize: '15px', background: '#FFFFFF', color: '#051004', resize: 'vertical', outline: 'none' }}
              placeholder={t('restaurant.describeIssue')}
              required
            />
          </label>

          <label style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <span style={{ fontFamily: 'Archivo, sans-serif', fontSize: '12.5px', fontWeight: 600, letterSpacing: '0.08em', textTransform: 'uppercase', color: 'rgba(5,16,4,0.6)' }}>
              {t('restaurant.contactOptional')}
            </span>
            <input
              type="text"
              name="contact"
              value={reportForm.contact}
              onChange={handleInputChange}
              style={{ border: '1px solid rgba(5,16,4,0.14)', borderRadius: '999px', padding: '12px 18px', fontFamily: 'Poppins, sans-serif', fontSize: '15px', background: '#FFFFFF', color: '#051004', outline: 'none' }}
              placeholder={t('restaurant.contactPlaceholder')}
            />
          </label>

          <div className="flex gap-3" style={{ paddingTop: '4px' }}>
            <button
              type="button"
              onClick={onClose}
              style={{ flex: 1, border: '1px solid rgba(5,16,4,0.14)', background: 'transparent', cursor: 'pointer', color: '#051004', fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '14.5px', padding: '13px 20px', borderRadius: '999px' }}
            >
              {t('restaurant.cancel')}
            </button>
            <button
              type="submit"
              disabled={reportSubmitting}
              style={{ flex: 1, border: 'none', cursor: reportSubmitting ? 'not-allowed' : 'pointer', background: '#EF4C23', color: '#FCFBF5', fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '14.5px', padding: '13px 20px', borderRadius: '999px', opacity: reportSubmitting ? 0.6 : 1 }}
            >
              {reportSubmitting ? t('restaurant.sending') : t('restaurant.sendReport')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ReportModal;
